import axios from "axios";
import { HeadApiModel } from "../api-models";

async function getSoloHeadModel(): Promise<HeadApiModel | null> {
  return axios.get("/api/head/mysolo").then((resp) => {
    return resp.data
      ? ({
          values: resp.data as Record<string, number>,
          labelOverrides: {},
          valueType: "PercentageFit",
          shape: "Circle",
          background: "SoloOrPerspective",
          fill: "Filled",
        } as HeadApiModel)
      : null;
  });
}

async function getViewpointsHeadModel(): Promise<HeadApiModel | null> {
  return axios.get("/api/head/myviewpoints").then((resp) => {
    return resp.data
      ? ({
          values: resp.data as Record<string, number>,
          labelOverrides: {},
          valueType: "PercentageFit",
          shape: "Diamond",
          background: "Viewpoints",
          fill: "Filled",
        } as HeadApiModel)
      : null;
  });
}

async function getTeamSoloHeadModel(headId?: string): Promise<HeadApiModel | null> {
  return axios.get(`/api/head/teamsolo/${headId}`).then((resp) => {
    return resp.data
      ? ({
          values: resp.data as Record<string, number>,
          labelOverrides: {},
          valueType: "PercentageFit",
          shape: "Circle",
          background: "SoloOrPerspective",
          fill: "Outline",
        } as HeadApiModel)
      : null;
  });
}

async function getTeamViewpointsHeadModel(headId?: string): Promise<HeadApiModel | null> {
  return axios.get(`/api/head/teamviewpoints/${headId}`).then((resp) => {
    return resp.data
      ? ({
          values: resp.data as Record<string, number>,
          labelOverrides: {},
          valueType: "PercentageFit",
          shape: "Diamond",
          background: "Viewpoints",
          fill: "Outline",
        } as HeadApiModel)
      : null;
  });
}

async function getTeamEffectivenessIndividualHeadModel(
  headId?: string,
): Promise<HeadApiModel | null> {
  return axios.get(`/api/head/teamviewpoints/${headId}`).then((resp) => {
    return resp.data
      ? ({
          values: resp.data as Record<string, number>,
          labelOverrides: {},
          valueType: "PercentageFit",
          shape: "Diamond",
          background: "Viewpoints",
          fill: "Outline",
        } as HeadApiModel)
      : null;
  });
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function useHeadModel() {
  return {
    getSoloHeadModel,
    getViewpointsHeadModel,
    getTeamSoloHeadModel,
    getTeamViewpointsHeadModel,
    getTeamEffectivenessIndividualHeadModel,
  };
}
